var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 3.33301H15.3332",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.666504H6.5C6.23478 0.666504 5.98043 0.771861 5.79289 0.959397C5.60536 1.14693 5.5 1.40129 5.5 1.6665V3.33317H10.5V1.6665C10.5 1.40129 10.3946 1.14693 10.2071 0.959397C10.0196 0.771861 9.76522 0.666504 9.5 0.666504Z",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.833V6.83301",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.833V6.83301",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5733 14.413C12.5548 14.6635 12.442 14.8978 12.2577 15.0685C12.0734 15.2392 11.8312 15.3337 11.58 15.333H4.42C4.16878 15.3337 3.92663 15.2392 3.74231 15.0685C3.558 14.8978 3.44521 14.6635 3.42667 14.413L2.5 3.33301H13.5L12.5733 14.413Z",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTrash;